import React, { Component } from "react"
import PropTypes from "prop-types"

import styles from "./styles.less"

export default class SidebarFilterPanel extends Component {
  static defaultProps = {
    className: "",
  }

  static propTypes = {
    title: PropTypes.string,
    className: PropTypes.string,
  }

  render() {
    return (
      <div>
        <div className={`${styles.mainHeader} section-filter-header`}>
          <div className={styles.headerTitle}>{this.props.title}</div>
        </div>
        <div className={styles.body}>{this.props.children}</div>
      </div>
    )
  }
}
